/**
 * Convert Bytes5 to generic Bytes
 *
 * @param {import('./Bytes5Type.js').Bytes5Type} bytes - Bytes5 to convert
 * @returns {import('../BytesType.js').BytesType} Generic Bytes
 *
 * @example
 * ```typescript
 * const genericBytes = Bytes5.toBytes(bytes);
 * ```
 */
export function toBytes(bytes) {
	return /** @type {import('../BytesType.js').BytesType} */ (
		/** @type {unknown} */ (bytes)
	);
}
